module.exports = __webpack_public_path__ + "img/box-close.a823bd04.png";